import React from 'react';
import { Section, FadeIn } from './ui/Section';
import { TrendingUp } from 'lucide-react';
export function Expectations() {
  return <Section background="warm" className="border-y border-[#E8D5DC]/50" data-id="element-16">
      <FadeIn data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-serif text-[#3D1F2E] mb-6" data-id="element-19">
            Qué cambia en 14 días
          </h2>
          <p className="text-[#7A5C6B] uppercase tracking-widest text-sm font-medium" data-id="element-20">
            Expectativas Reales
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-21">
        <div className="bg-white/80 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-sm max-w-2xl mx-auto" data-id="element-22">
          <h3 className="font-serif text-xl text-[#3D1F2E] mb-6" data-id="element-23">
            Vas a notar:
          </h3>
          <ul className="space-y-4 mb-8" data-id="element-24">
            {['Menos compras "ROJAS"', 'Menos culpa post‑compra', 'Más claridad sobre tus gatillos', 'Más control de tus tarjetas (sin drama)', 'Un plan realista para recaídas (sin tirarte a la basura)'].map((item, i) => <li key={i} className="flex items-center text-[#7A5C6B]" data-id="element-25">
                <TrendingUp className="w-5 h-5 text-[#28A745] mr-3 flex-shrink-0" data-id="element-26" />
                {item}
              </li>)}
          </ul>

          <div className="border-t border-[#E8D5DC] pt-6 mt-6 text-center" data-id="element-27">
            <p className="text-[#7A5C6B] mb-2" data-id="element-28">
              No te prometo una vida perfecta.
            </p>
            <p className="font-serif text-2xl text-[#3D1F2E] italic" data-id="element-29">
              Te prometo algo más útil: <br data-id="element-30" />
              <span className="text-[#C4467E]" data-id="element-31">
                volver a sentirte confiable para ti misma.
              </span>
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}